// 开发票api
import http from './http';

const httpService = (requestUrl, data?, config?, method?) => {
  const params = method === 'GET' ? { params: data } : { data };
  return http({
    ...config,
    method: method || 'POST',
    url: requestUrl,
    ...params,
  });
};

// 获取汇总开票订单信息
const getSummaryInvoice = (data) => httpService('/invoices/summary', data);

// 提交开票信息
const submitInvoices = (data) => httpService('/invoices/submit', data);

// 查询订单下的发票信息
const getOrderInvoices = (data) => httpService('/invoices/order/invoices', data, {}, 'GET');

// 查询房费明细
const getRoomIncomeDetail = (data) => httpService('/invoices/room-income/detail', data);

// 查询开票商品明细
const getGoodsDetail = (data) => httpService('/invoices/goods/detail', data);

// 查询房间开票订单
const queryRoomBillingOrders = (data) => httpService('/invoices/query-room-billing-orders', data);

// 查询其他开票订单
const queryOtherBillingOrders = (data) => httpService('/transactions/page/invoice', data);

// 获取开票操作信息详情
const getInvoicesDetail = (data) => httpService('/invoices/detail', data, {}, 'GET');

// 获取开票操作信息详情
const getInvoicesTypeList = (data) => httpService('/invoices/types/list', data, {}, 'GET');

export default {
  getSummaryInvoice,
  submitInvoices,
  getOrderInvoices,
  getRoomIncomeDetail,
  getGoodsDetail,
  queryRoomBillingOrders,
  queryOtherBillingOrders,
  getInvoicesDetail,
  getInvoicesTypeList,
};
